import { EventTypeIdentifier } from '../enums';

export interface ExceptionalPlate {
  plate: string;
  state: string;
  comment?: string;
  group: PriviledgedGroup;
}

export enum PriviledgedGroup {
  Bus = 'Bus',
  Police = 'Police',
  Firemen = 'Firemen',
  Medical = 'Medical',
  UPS = 'UPS',
  City = 'City services',
  Other = 'Other',
}

export type MatchMode = 'exact' | 'prefix';

export interface PostPermittedPlate {
  categorization_code: string;
  event_type_identifiers: EventTypeIdentifier[];
  state_code: string;
  license_plate: string;
  permitted_plate_id?: number;
  match_mode?: MatchMode;
}

export interface PermittedPlate extends PostPermittedPlate {
  created_at?: string;
  created_by?: string;
  permitted_plate_id: number;
  updated_at?: string;
  event_type_identifier: EventTypeIdentifier;
  match_mode: MatchMode;
}
